<template>
  <div class="amaze-email-address-input-component amaze-email">
    <!-- Primary Email Field -->
    <v-text-field v-model="email" name="amazeEmailAddressEmail" :rules="validateEmail" v-on:change="emailChanged" @input="emailChanged" class="primaryEmail" outlined>
        <template slot="label">
            <slot name="label">Email</slot><span v-if="required" class='star'>*</span>
        </template>
    </v-text-field>
    <!-- Confirmation Email Field -->
    <v-text-field v-if="confirm" name="amazeConfirmEmailAddressEmail"  v-model="confirmation" :rules="validateConfirmation" v-on:change="emailChanged" @input="emailChanged" class="confirmEmail">
        <template slot="label">
            Confirm <slot name="label">Email</slot><span v-if="required" class='star'>*</span>
        </template>
    </v-text-field>
  </div>
</template>

<script>
/*
 * <AmazeEmailAddressInput v-model="email" :confirm="true" :required="true">
 *  <template slot="label">E-mail:</template>
 * </AmazeEmailAddressInput>
 *
 * 2021-11-11: There's been a request to include an input to
 * force people to re-enter an email address to see if they
 * match.
 *
 */
export default {
  props: {
    // Use the email confirmation input.
    confirm: {
      type: Boolean,
      default: true
    },
    // Make email a required field.
    required: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    matches: function () {
      return this.confirm ? this.email === this.confirmation : true;
    },
    validateEmail: function() {
      return this.required ? this.rules.email.concat(this.rules.required) : this.rules.optional;
    },
    validateConfirmation: function() {
      return this.rules.confirm.concat(this.validateEmail);
    }
  },
  data() {
    return {
      email: null,
      confirmation: null,
      "rules": {
        confirm: [v => (v === this.email) || 'Please ensure the emails match.'],
        email: [v => /@/.test(v) || "Please enter a valid email."],
        // This does email validation, but allows for the email to also be empty (b/c it's optional).
        optional: [v => (/@/.test(v) || !v) || "Please enter a valid email."],
        required: [v => !!v || "Email is required."]
      }
    };
  },
  methods: {
    emailChanged() {
      if (this.email && this.matches) {
        this.$emit('input', this.email);
        this.$emit('emailAddress', this.email);
      }
    }
  }
};
</script>
